import { shimmer, toBase64 } from "@src/utils/shimmer";
import Image from "next/image";
import React from "react";
import flower from "../../../../public/images/pinkFlowerImage.png";
import { EventBySlugQuery } from "@src/@types/api.d";
import Icon from "@src/components/Icon";

interface IFooter {
  slug: EventBySlugQuery | undefined;
}

const Footer = ({ slug }: IFooter) => {
  return (
    <footer className="h-[22rem] w-full overflow-hidden bg-[#725A3F] flex flex-col">
      <div className="h-[15rem] flex flex-col gap-2 justify-center items-center relative px-8 overflow-hidden">
        <Icon iconName="ringWhite" />

        <p className="font-ntFab text-[1rem] md:text-[1.5rem] leading-[100%] mt-[2rem] font-normal tracking-[0.2rem] text-[#EAE4CC]">
          MADE WITH{" "}
          <a
            href="https://www.inawo.com"
            target="_blank"
            rel="noopener noreferrer"
            className="border-b-[0.5px] border-[#EAE4CC] pb-[0.5px]"
          >
            INAWO
          </a>
        </p>

        <p className="font-ebGaramond text-[1rem] md:text-[1.5rem] leading-[100%] mt-[0.5rem] w-[60%] md:w-full text-[#EAE4CC] text-center">
          The number one website maker for the culturally relevant
        </p>
      </div>
    </footer>
  );
};

export default Footer;
